module.exports = __webpack_public_path__ + "static/jti logo-7a8c1ff7dfac634b29a75b1a29b3d80c.png";